export default "__VITE_ASSET__CFzGkTj___";